angular.module('app').controller('SubjectCtrl', function($controller, $scope, $mdDialog, appUtils, $http) {
    "ngInject";

    var main = this;

    main.name = 'event_signup';
    main.link = !main.embedded;
    main.defaults = {
        'answers': {},
        'subject': {
            'user_subjects': []
        },
        'contacts': []
    };

    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    main.formatDay = function(day) {
        var out = moment.parseZone(day.date).format('ddd MM/DD/YYYY');
        if(!day.date || out == 'Invalid date') {
            out = '';
        }

        if (day.name) {
            out += ' ' + day.name;
        }

        if(day.limit) {
            out += ' (Limit: ' + day.limit + ')';
        }

        var count = (main.day_count || {})[day.id];
        if(count) {
            out += ' (Signed Up: ' + count + ')';
            if(day.limit) {
                out += ' (Avail: ' + (day.limit - count) + ')';
            }
        }
        return out;
    }

    main.loadEventQuestions = function() {
        if(!main.item.event_id) {
            return;
        }

        $http({
            'url': '/api/v1/admin/event/' + main.item.event_id + '/event_question_relationships',
            'method': 'GET',
        }).then(
            function(response) {
                main.item.event.event_question_relationships = response.data.objects.map(function(qr) {
                    delete qr.question.event;
                    if(qr.question.options) {
                        qr.question.choices = qr.question.options.choices
                    }
                    return qr;
                });
            }
        );
    }

    main.loadDayCount = function() {
        if(!main.item.event_id) {
            return;
        }
        $http({'method': 'GET', 'url': '/api/v1/admin/event/' + main.item.event_id + '/day-count'}).then(

            function(response) {
                main.day_count = response.data;
            }
        );
    }

    main.subjectQuery = {};

    main.userSearch = function(text) {
        var params = appUtils.emptyQuery();
        if(text) {
            params.q.filters.push({
                'or': [
                    {
                        'name': 'first_name',
                        'op': 'ilike',
                        'val': '%' + text + '%'
                    },
                    {
                        'name': 'last_name',
                        'op': 'ilike',
                        'val': '%' + text + '%'
                    },
                    {
                        'name': 'email',
                        'op': 'ilike',
                        'val': '%' + text + '%'
                    }
                ]
            });
        }
        var eqFields = ['all_customers', 'first_name', 'last_name'];
        eqFields.forEach(function(field) {
            var val = main.subjectQuery[field];
            if(val != null && val !== '') {
                var op = 'eq';
                if(field != 'all_customers' && (main.subjectQuery[field + '_exact'] !== true)) {
                    val = '%' + val + '%';
                    op = 'ilike';
                } 
                params.q.filters.push({
                    'name': field,
                    'op': op,
                    'val': val
                });
            }
        });
        params.q.order_by = [{"field":"last_name","direction":"asc"}]
        return appUtils.search('user', text, params, true);
    };

    main.subjectLinkQuery = {};

    main.subjectSearch = function(text) {
        var hasFilters = main.subjectLinkQuery.first_name || main.subjectLinkQuery.last_name;
        if(!text && !hasFilters) {
            return [];
        }

        var params = {};
        if(text) {
            params.q = text;
        }
        if(main.subjectLinkQuery.first_name) {
            params.first_name = main.subjectLinkQuery.first_name;
            if(main.subjectLinkQuery.first_name_exact) {
                params.first_name_exact = 'true';
            }
        }
        if(main.subjectLinkQuery.last_name) {
            params.last_name = main.subjectLinkQuery.last_name;
            if(main.subjectLinkQuery.last_name_exact) {
                params.last_name_exact = 'true';
            }
        }

        return $http({
            'method': 'GET',
            'url': '/api/v1/admin/subject_link_search',
            'params': params
        }).then(
            function(response) {
                return response.data.objects;
            }
        );
    }

    main.selectSubject = function(subject) {
        main.selectedSubject = subject;
        main.item.subject = subject;
        main.subjectResults = [];
        main.doLink();
    };

    main.clearSubjectSelection = function() {
        main.selectedSubject = null;
        main.item.subject = { 'user_subjects': [], 'users': [] };
        main.item.subject_id = null;
    };

    main.addNewContact = function() {
        $mdDialog.show({
            'controller': 'CustomerCtrl',
            'controllerAs': 'main',
            'templateUrl': '/static/admin/templates/customer.html',
            'multiple': true,
            'locals': {'id': 'new', 'embedded': true},
            'bindToController': true
        }).then(
            function(customer) {
                main.item.subject.users.push(customer);
            }
        );
    };

    main.doLink = function() {
        if(!main.item.subject) {
            return;
        }
        main.item.subject_id = main.item.subject.id;
        if(!main.item.first_name) {
            main.item.first_name = main.item.subject.first_name;
        }
        if(!main.item.last_name) {
            main.item.last_name = main.item.subject.last_name;
        }
    };

    main.removeUser = function(us) {
        return $http({
            'method': 'DELETE',
            'url': '/api/v1/admin/subject/' + us.subject_id + '/user/' + us.user_id,
        }).then(
            function(response) {
                appUtils.remove(us, 'user_id', main.item.subject.user_subjects);
            }
        );
    }

    main.addUser = function(user) {
        if(!user) {
            return;
        }
        main.item.subject.user_subjects.push({
            'user_id': user.id,
            'subject_id': main.item.subject.id,
            'user': user
        });
        main.customerToAdd = null;
    }

    main.save = function() {
        if($scope.itemForm.$invalid) {
            var errors = Object.keys($scope.itemForm.$error).map(function(error) {
                return $scope.itemForm.$error[error].map(function(field) {
                    return field.$name;
                });
            });
            appUtils.toast('Please correct the following fields: ' + errors.join(', '));
            return false;
        }
        if((main.id == 'new' && !main.link) || main.update_subject) {
            if(!main.item.subject) {
                main.item.subject = { 'user_subjects': [], 'users': [] };
            }
            main.item.subject.first_name =  main.item.first_name;
            main.item.subject.last_name =  main.item.last_name;
        }

        main._save();
    };
});
